@if (formGroup) {
    <div class="flex flex-col grow gap-7 justify-between" style="height: 100%">
        <form
            [formGroup]="$any(formGroup)"
            class="flex flex-col grow gap-7 mt-6"
        >
            <z-float-label
                [label]="'Επωνυμία Επιχείρησης'"
                formControlName="Brand"
            ></z-float-label>

            <ng-container formGroupName="Address">
                <z-float-label
                    [label]="'Πόλη'"
                    formControlName="CityEx"
                ></z-float-label>
                <z-float-label
                    [label]="'Οδός'"
                    formControlName="StreetName"
                ></z-float-label>
                <z-float-label
                    [label]="'Αριθμός'"
                    formControlName="StreetNumber"
                ></z-float-label>
                <z-float-label
                    [label]="'Τ.Κ'"
                    formControlName="PostalCode"
                ></z-float-label>
            </ng-container>
            <z-float-label
                [label]="'Δραστηριότητα'"
                formControlName="Occupation"
            ></z-float-label>
            <z-float-label
                [label]="'Δ.Ο.Υ'"
                formControlName="TAXOffice"
            ></z-float-label>
            <z-float-label
                [label]="'Τηλέφωνο'"
                formControlName="Phone"
            ></z-float-label>
            <z-float-label
                [label]="'EMail'"
                formControlName="EMail"
            ></z-float-label>
        </form>

        <!-- class="flex flex-auto flex-wrap gap-4 justify-content-between align-items-end" -->
        <div class="flex grow flex-wrap gap-4 justify-between items-end">
            <!-- <p-button label="Ακύρωση" severity="secondary" /> -->
            <div></div>

            <p-button label="Αποθήκευση" (onClick)="saveInvoiceIssuer()" />
        </div>
    </div>
}
